var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('checklist-form',{attrs:{"checklistTemplateObj":_vm.checklistTemplateObj,"token":_vm.accessToken,"defaultMappingValues":_vm.defaultMappingValues},on:{"update":_vm.onSuccessHandler,"back":_vm.backToList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }